@import '../../../assets/styles/variables';
@import '../../../assets/styles/typography';
@import '../../../../node_modules/@cpt/pci/postnl-styles/settings';
@import '../../../../node_modules/@cpt/pci/postnl-styles/tools/utilities';

:host(*) {
    all: initial;
    font-size: 16px;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss03' on, 'ss01' on;
}

// Prevents the user from scrolling when menu is open on mobile
body.noscroll {
    position: fixed;
    max-width: 100vw;
    max-height: 100vh;
    overflow: hidden;
}

.pnl-navigation {
    box-sizing: border-box;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss03' on, 'ss01' on;

    .pnl-header__main--mobile & {
        position: absolute;
        top: 72px;
        right: 0;
        bottom: 0;
        left: 0;
        height: calc(100vh - 72px);
        padding: 1em 1em 0;
        z-index: 999999;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        background-color: $color-white;
    }

    //global reset for lists with the navigation
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }
}

.pnl-navigation-container {
    @media (min-width: $bp-nav) {
        display: flex;
        position: static;
        flex-direction: row;
        align-items: center;
        width: auto;
        height: auto;
        overflow: visible;
    }
}

.pnl-navigation__list {
    .pnl-header__main--mobile & {
        padding-bottom: 1em;
    }

    @media (min-width: $bp-nav) {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    @media (min-width: 75em) {
        gap: 20px;
    }
}

.pnl-navigation__sublist-wrapper {
    @media (min-width: $bp-nav) {
        position: absolute;

        top: 50px;
        width: 100%;
        height: 30px;
    }
}

.pnl-navigation__sublist {
    padding-left: 1em;

    @media (min-width: $bp-nav) {
        display: flex;
        position: absolute;
        top: 12px;
        padding-left: 0;
        border: 1px solid $color-border-default;
        background: $color-white;
        white-space: nowrap;
        z-index: 9999;

        &::before {
            content: '';
            display: block;
            position: absolute;
            width: 16px;
            height: 16px;
            border-left: 1px solid $color-border-default;
            border-top: 1px solid $color-border-default;
            border-right: 1px solid transparent;
            border-bottom: 1px solid transparent;
            background-color: $color-white;
            transform: rotate(45deg);
            left: 36px;
            z-index: 99999;
            top: -8px;
        }
    }
}

//list items
.pnl-navigation__item {
    position: relative;
    padding: 1.5em 0;
    border-bottom: 1px solid $color-border-default;

    &:last-child {
        border-bottom: 0;
    }

    @media (min-width: $bp-nav) {
        border-bottom: 0;
        padding: 1.75em 0;
    }

    &.active {
        // The transition waits for 300ms to allow the search bar to shrink.
        // Otherwise the menu-items might wrap because there is not enough space,
        // making them jump around.
        transition: opacity 100ms ease-in 300ms;
        opacity: 1;
    }

    &.hidden {
        opacity: 0;
        height: 0;
        overflow: hidden;
    }

    //items in the sublist don't need a border
    .pnl-navigation__sublist & {
        border-bottom: 0;

        @media (min-width: $bp-nav) {
            padding: 0;
        }
    }
}

.pnl-navigation__wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    @media (min-width: $bp-nav) {
        justify-content: center;
    }
}

pnl-navigation-sub-menu {
    display: block;
    flex-basis: 100%;
    background-color: $color-white;
}

//these toggle buttons are for keyboard users
.pnl-navigation__sub-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.25s ease-in-out;
    height: 24px;
    width: 24px;
    border: none;
    border-radius: 0.25rem;
    background: transparent;
    color: $color-icon-default;

    svg {
        width: 16px;
        height: 16px;
    }

    @media (max-width: $bp-nav) {
        margin-left: auto;
    }

    @media (min-width: $bp-nav) {
        &:focus:not(:focus-visible) {
            outline: none;
        }

        &:focus-visible {
            outline-color: $color-border-focus-outline;
            outline-style: solid;
            outline-width: 2px;
            outline-offset: 1px;
        }
    }

    &[aria-expanded='false'] {
        transform: rotate(180deg);
    }
}

//navigation list links
.pnl-navigation__link {
    display: block;
    position: relative;
    border-bottom: none;
    border-radius: 0.25rem;
    color: $color-text-button-secondary-default;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss03' on, 'ss01' on;
    font-weight: 400;
    line-height: 1.6;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    &:active {
        background-color: #ffffff00;
        border-color: #ffffff00;
        color: $color-border-focus-outline;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }

    &:focus-visible {
        outline-color: $color-border-focus-outline;
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 1px;
    }

    @media (min-width: $bp-nav) {
        //links within the sublist
        .pnl-navigation__sublist & {
            padding: 0.875rem 1.125rem;
            font-size: 0.875rem;
        }
    }

    //links that are within the special wrapper
    .pnl-navigation__list-wrapper--row & {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1.425em 0;
    }

    //active state needs to be toggled by JS
    &--active::after {
        @media (min-width: $bp-nav) {
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            height: 5px;
            background-color: $orange;
            content: '';
        }
    }

    &--active:hover,
    &--active:focus {
        &::after {
            display: none;
        }
    }

    &--home {
        display: block;
        padding: 0;
        border-bottom: 0;

        img {
            height: 40px;
            width: 40px;

            @media (min-width: $bp-nav) {
                width: 88px;
                height: 88px;
            }
        }

        @media (max-width: $bp-nav) {
            > .pnl-navigation__link--replacement {
                display: none;
            }
        }

        &-mobile {
            position: absolute;
            left: 50%;
            width: 2.5em;
            height: 2.5em;
            transform: translateX(-50%);
        }
    }
}

.pnl-navigation__link .pnl-navigation__link-txt--mobile {
    @media (min-width: $bp-nav) {
        display: none;
    }
}

.pnl-navigation__link-img {
    width: 5.75em;
}

// wrappers within the lists
.pnl-navigation__list-wrapper--row {
    display: flex;
    flex-wrap: wrap;

    @media (min-width: $bp-nav) {
        flex-wrap: nowrap;

        & > *:nth-child(n + 1) {
            border-left: 1px solid $color-border-default;
        }
    }

    > * {
        flex: 0 0 50%;
        border-top: 1px solid $color-border-default;

        @media (min-width: $bp-nav) {
            flex: 0 0 auto;
            min-width: 9em; //unfortunate width necessary
            border-top: 0;
        }

        &:nth-child(even) {
            border-left: 1px solid $color-border-default;
        }
    }
}

.pnl-navigation__search {
    .pnl-navigation & {
        display: block;
        margin-block-end: 1rem;
    }
}
